import { axios } from '@Root/API'

export const get = (studyProgrammeId, referencePeriodStudentLoadId) => {
	return axios.get(`course-session/${studyProgrammeId}/reference-period-student-load/${referencePeriodStudentLoadId}`)
}
